import React, { useLayoutEffect, useEffect, useMemo, useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useTemplate, useUser } from 'components/hooks';
import { HeadlinePage, WorkflowForm, Workflow } from 'components/common';
import { useTranslation } from 'react-i18next';
import { formatProjectItems, workflowPolicies } from 'helpers';
import { WorkflowAbout, WorkflowNotification } from './WorkflowStepper';
import { useStyle } from './styles';
import { Paper, Button, Divider, Grid, CircularProgress, Backdrop, Box, Typography } from '@mui/material';
import { ROUTES } from 'consts';
import { useTheme } from '@mui/material/styles';
import { withPermission } from 'hoc';
const wfexample = require('../../../consts/workflow-example-ejecucion.json');

function createMapping(projects) {
  let result = {};
  projects.forEach((p, i) => {
    result[p.value] = p;
  });
  return result;
}

const  WorkflowFormDumb = ({ defaultValues, handleOnSubmit, isEdit, validPermission }) => {
  const { parameters } = useUser();
  const theme = useTheme();
  const { getUserProject, isLoaded, fieldData, fieldDataConst } = useTemplate();
  const [switchTab, setSwitchTab] = useState(false);
  const projects = formatProjectItems(parameters);
  const [t] = useTranslation();
  const classes = useStyle();
  const methods = useForm({
    defaultValues: useMemo(() => {
      return defaultValues;
    }, [defaultValues])
  });
  const { handleSubmit, watch, setValue, reset, getValues } = methods;
  const watchProject = watch('project');
  const watchTasks = watch("workflowDefinition");
  const projectsMap = createMapping(projects);

  const setDataQuery = () => {
    getUserProject({
      query: {
        projectId: projectsMap[watchProject].value,
        baseUrl: projectsMap[watchProject].base_url,
      },
    });
  };

  function handleSwitchTab() {
    window.scrollTo(0, 0);
    setSwitchTab(!switchTab);
  }


  function handleCancelTasks() {
    handleSwitchTab();
  }

  function handleSubmitTasks(tasks) {
    setValue("workflowDefinition", tasks);
    handleSwitchTab();
  }

  useEffect(() => {
    if (isEdit) reset(defaultValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues]);

  useLayoutEffect(() => {
    setDataQuery();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchProject]);

  useEffect(() => {
    setValue('userProject', !fieldData.userProjects.length ? '' : fieldData.userProjects[0].value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fieldData]);

  return (
    <>
      <Backdrop
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoaded.post || isLoaded.put}
      >
        <CircularProgress color="primary" />
      </Backdrop>

      <HeadlinePage
        title={!switchTab ? (isEdit ? 'workflowEdit.headline' : 'workflowCreate.headline') : 'workflowEdit.components.task.headline'}
        goBack={!switchTab ? ROUTES.WORKFLOW_LIST : handleSwitchTab}
      />

      <Paper sx={{ display: switchTab ? 'none!important' : 'flex' }} className={classes.paperStyle}>
        <FormProvider { ...methods }>
          <form onSubmit={handleSubmit(handleOnSubmit)}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <WorkflowAbout isEdit={isEdit} methods={methods} policies={workflowPolicies} fieldData={fieldData} projects={projects} isLoaded={isLoaded.fieldData} />
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Divider sx={{ padding: 2 }} />
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Box sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between' }}>
                  <Typography variant="h6" sx={{ padding: '8px 0px' }}>
                  {t('workflowList.stepper.workflow.title')}
                  </Typography>
                    <Button variant="outlined" onClick={handleSwitchTab}>
                      {t('workflowList.stepper.workflow.buttonLabel')}
                    </Button>
                </Box>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Box sx={{
                  width: '100%',
                  height: '300px',
                  overflow:'hidden',
                  border: `1px solid ${theme.palette.grey[400]}`,
                  borderRadius: 1
                }}>
                  { (watchTasks && watchTasks.length > 0) ?
                    (
                      <Workflow
                        wfParam={watchTasks}
                        updateWF={(x)=>{console.info(x)}}
                        mode="ej"
                        scrollScale={true}
                      />
                    )
                    :(
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                        <Typography variant="h5">{t('workflowEdit.components.task.notResults')}</Typography>
                      </Box>
                    )
                  }
                </Box>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Divider sx={{ padding: 2 }} />
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12}>
                <WorkflowNotification
                  methods={methods}
                  policies={workflowPolicies}
                  fieldData={fieldData}
                  fieldDataConst={fieldDataConst}
                  isLoaded={isLoaded.fieldData}
                  handleSubmit={handleSubmit}
                />
              </Grid>

              <Grid item md={2} lg={3} />
                <Grid item xs={12} sm={12} md={8} lg={6}>
                  <Button variant="contained" sx={{ width: '100%' }} type='submit'>
                    {isEdit ? t('workflowEdit.components.submit') : t('workflowCreate.components.submit')}
                  </Button>
                </Grid>
              <Grid item md={2} lg={3} />
            </Grid>
          </form>
        </FormProvider>
      </Paper>

      { switchTab &&
        <Box>
          <WorkflowForm
            wfParam={defaultValues.workflowDefinition}
            mode={"ed"}
            projectId={watchProject}
            handleCancelSubmit={handleCancelTasks}
            handleConfirmSubmit={handleSubmitTasks}
          />
        </Box>
      }
    </>
  );
}

export default withPermission(WorkflowFormDumb, "workflow");
